import { render, staticRenderFns } from "./DamageLocator.vue?vue&type=template&id=c57e0228&scoped=true"
import script from "./DamageLocator.vue?vue&type=script&lang=ts"
export * from "./DamageLocator.vue?vue&type=script&lang=ts"
import style0 from "./DamageLocator.vue?vue&type=style&index=0&id=c57e0228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57e0228",
  null
  
)

export default component.exports